import MuiPaper, { PaperProps as MuiPaperProps } from '@mui/material/Paper';

export type PaperProps = MuiPaperProps;

export const Paper = (props: PaperProps) => {
  return <MuiPaper {...props} />;
};
